import interpolate from 'lib/interpolate';
import { GET, POST } from '../store/lib/xhr';
import { Kibana } from '../utils/trackKibana';

const kibana = new Kibana('InteractiveApi');

export default function InteractiveApi(
  { api_url, video_config_url, token },
  callbacks,
) {
  const pendingQuery = [];

  let authorization = `Bearer ${token}`;

  const configPath = video_config_url.replace(api_url, '');
  const [, version] = configPath.match(/^\/v(\d+)\//);

  const query = (path, method = GET, payload = undefined) => {
    const url = api_url + path;
    return method(
      url,
      [
        ['Authorization', authorization],
        ['Accept', 'application/json'],
        /*
          ['Cache-control', 'max-age=300' /!* 'no-cache' /!* TODO: which cache-control we should use? !/ *!/],
      */
      ],
      payload,
    ).catch((error) => {
      const { code } = JSON.parse(error.message);
      callbacks[code]?.();
      if (code === 401) {
        return new Promise((resolve) => {
          pendingQuery.push(() => resolve(query(path, method)));
        });
      } else {
        error.url = url;
        kibana.error(error);
      }
      throw error;
    });
  };

  return {
    updateToken(newToken) {
      authorization = `Bearer ${newToken}`;
      pendingQuery.forEach((callback) => callback());
      pendingQuery.length = 0;
    },
    init() {
      return query('/v1/init', POST);
    },
    getConfig(object) {
      const url = interpolate(configPath, object);
      return query(url).then((config) => {
        config._version = version;

        // TODO: remove after BE updates config for quiz
        config.quiz ??= {
          enabled: true,
        };

        // TODO: move here all other config "modifications" from fetchObjectConfig,
        //  except replacing video_id in templates
        return config;
      });
    },
    post(path, payload) {
      return query(path, POST, payload);
    },
    /*
        fetchEventsHistory({
          object_id,
          start_ts,
          end_ts
        }){
          const url = replace(video_config_url, { object_id });
          return query
        },
    */
    query,
  };
}
